import {IRecurso} from "@models/recurso/IRecurso.ts";
import {Button, FormControl, Grid, InputLabel, MenuItem, Select} from "@mui/material";
import {UsuarioPesquisa} from "@components/usuario/UsuarioPesquisa.tsx";
import React, {useState} from "react";
import {IUsuario} from "@models/conta/IUsuario.ts";
import {IRecursoMembro} from "@models/recurso/IRecursoMembro.ts";
import {FuncaoRecurso, getNivelPermissoes} from "@models/conta/funcaoRecurso.ts";
import {AddOutlined} from "@mui/icons-material";
import {AddRecursoMembro} from "@localization/siteMap/endpoints/_RecursosEndpoints.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

interface AddRecursoMembroProps {
    recurso: IRecurso,
    onCreate?: (m: IRecursoMembro[]) => void
}

export const AddRecursoMembroComponent: React.FC<AddRecursoMembroProps> = ({recurso, onCreate}) => {
    const {Get} = useApi()
    const {createAlertFromResponse} = useAlert()
    const [usuario, setUsuario] = useState<IUsuario | undefined>(undefined)
    const [niveisPermissao] = useState(getNivelPermissoes())

    const [funcaoSelected, setFuncaoSelected] = useState<FuncaoRecurso>('Solicitante')

    const incluirHandler = () => {
        if (usuario != null)
            Get(AddRecursoMembro([{
                idRecurso: recurso.id,
                idMembro: usuario?.id,
                funcaoRecurso: funcaoSelected
            }])).then(x => {
                createAlertFromResponse(x)
                if (x.status == 'Success') {
                    if (onCreate != null) {
                        onCreate(x.items)
                    }
                }
            })
    }

    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <UsuarioPesquisa onItemSelected={setUsuario}/>
            </Grid>
            <Grid size={12}>
                <FormControl variant={'filled'} fullWidth>
                    <InputLabel variant={'filled'}>Função</InputLabel>
                    <Select variant={'filled'} label={'Função'} value={funcaoSelected} onChange={(e) => {
                        setFuncaoSelected(e.target.value as FuncaoRecurso)
                    }}>
                        {niveisPermissao.map((n) => (
                            <MenuItem key={n} value={n}>{n}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={12}>
                <Grid container justifyContent={'space-between'}>
                    <Grid/>
                    <Button color={'success'}
                            onClick={incluirHandler}
                            endIcon={<AddOutlined/>}>Incluir</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}